// Define the cookie structure with their values and expiration
export const Cookies = {
  hideAgentModeInfo: {
    key: "hideAgentModeInfo",
    defaultValue: "false",
    expires: 365,
    values: ["true", "false"] as const,
  },
  hideM365Info: {
    key: "hideM365Info",
    defaultValue: "false",
    expires: 365,
    values: ["true", "false"] as const,
  },
  hideVoiceModeInfo: {
    key: "hideVoiceModeInfo",
    defaultValue: "false",
    expires: 365,
    values: ["true", "false"] as const,
  },
  voiceInternalDataConsent: {
    key: "voiceInternalDataConsent",
    defaultValue: "",
    expires: 365,
    values: ["v2", ""] as const,
  },
  gdprAccepted: {
    key: "gdprAccepted",
    defaultValue: "",
    expires: 180,
    values: null, // any string allowed
  },
  whatsNew: {
    key: "whatsNew",
    defaultValue: "",
    expires: 365,
    values: null,
  },
  sidebarState: {
    key: "sidebar:state",
    defaultValue: "",
    expires: 60 * 60 * 24 * 7,
    values: null,
  },
  sidebarWidth: {
    key: "sidebar:width",
    defaultValue: "",
    expires: 60 * 60 * 24 * 7,
    values: null,
  },
} as const

// Infer types from the cookie definitions
export type CookieKey = keyof typeof Cookies
export type CookieValue<T extends CookieKey> =
  (typeof Cookies)[T]["values"] extends readonly string[]
    ? (typeof Cookies)[T]["values"][number]
    : string
